import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2a5d32', // Közepes zöld (pl. gombok, kiemelések)
      light: '#5b8159ff', // Világos zöld
      dark: '#1b331f',  // Sötét zöld (pl. fejléc)
      contrastText: '#ffffff', // Fehér szöveg a primary színeken
      50: '#eaf1eb', // Halvány tónus (tipp-dobozok, hover) — a sx `primary.50` erre old fel
    },
    // Halvány (50-es) tónusok: a kódban sok helyen `info.50`, `warning.50` stb. háttér szerepel;
    // ezek nélkül a MUI érvénytelen CSS-t ír, és a doboz háttér nélkül marad
    info: { main: '#0288d1', 50: '#e8f4fb' },
    warning: { main: '#b85c00', 50: '#fdf3e6' },
    success: { main: '#2e7d32', 50: '#edf6ee' },
    error: { main: '#d32f2f', 50: '#fdeeee' },
    secondary: {
      main: '#edbe5f', // Sárga/arany (pl. másodlagos gombok, akcentusok)
      light: '#f0eee9', // Nagyon világos bézs
      dark:  '#f5f1e6', //'#dad1be',  // Világos bézs/szürke
      contrastText: '#000000', // Fekete szöveg a secondary színeken
    },
    background: {
      default: 'rgba(247, 224, 184, 0.31)',
      paper: '#f5f1e6',//'#f0e1c3ff', // Kártyák, panelek háttérszíne
    },
    text: {
      primary: '#1b331f',
      secondary: '#5b6e5d',
      disabled: '#9aab9c',
    },
    divider: 'rgba(42, 93, 50, 0.12)',
  },
  typography: {
    fontFamily: [
      '"Inter"',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    // Címek Playfair Display-jel
    h1: {
      fontFamily: '"Playfair Display", serif',
      fontSize: '3rem',
      fontWeight: 700,
    },
    h2: {
      fontFamily: '"Playfair Display", serif',
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h3: {
      fontFamily: '"Playfair Display", serif',
      fontSize: '2rem',
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"Playfair Display", serif',
      fontSize: '1.75rem',
      fontWeight: 600,
      lineHeight: 1.3,
      letterSpacing: '-0.01em',
    },
    h5: {
      fontFamily: '"Playfair Display", serif',
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.35,
      letterSpacing: '-0.005em',
    },
    h6: {
      fontFamily: '"Playfair Display", serif',
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.4,
      letterSpacing: '0em',
    },
    // Normál szövegek Inter-rel (sans-serif)
    body1: {
      fontFamily: '"Inter", sans-serif',
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontFamily: '"Inter", sans-serif',
      fontSize: '0.875rem',
      lineHeight: 1.6,
      letterSpacing: '0.01em',
    },
    button: {
      fontFamily: '"Inter", sans-serif',
      fontWeight: 600,
    },
    caption: {
      fontFamily: '"Inter", sans-serif',
      fontSize: '0.75rem',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    overline: {
      fontFamily: '"Inter", sans-serif',
      fontSize: '0.6875rem',
      fontWeight: 600,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
    },
    subtitle1: {
      fontFamily: '"Inter", sans-serif',
      fontSize: '1rem',
      fontWeight: 500,
    },
    subtitle2: {
      fontFamily: '"Inter", sans-serif',
      fontSize: '0.875rem',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none',
          transition: 'background-color 0.18s ease, box-shadow 0.18s ease, transform 0.12s ease',
          '&:active': { transform: 'scale(0.98)' },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
        colorPrimary: {
          backgroundColor: '#1b331f',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(27, 51, 31, 0.08)',
          transition: 'box-shadow 0.2s ease, transform 0.2s ease',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
        },
        elevation3: {
          boxShadow: '0 4px 16px rgba(27, 51, 31, 0.10)',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
    MuiPickersOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '16px',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: { borderRadius: 4 },
        bar: {
          borderRadius: 4,
          transition: 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
        },
      },
    },
  },
});

export default theme;